<template>
  <div style="height: 100dvh">
    <div class="job-parentDiv">
      <div class="d-flex align-items-center h-100 jov-main-divs">
        <div class="job-left-div h-100">
          <div class="job-left-innerdiv job-left-innerdiv-height">
            <div class="job-left-head">Job Registration Form</div>
            <div class="job-left-subhead mt-2">
              The Hire3x Evaluation Engine is a comprehensive suite of products
              that’ll help you hire the best developers, test programming
            </div>
          </div>
          <div class="w-100">
            <img
              class="w-100"
              src="../../assets/NewJobsRegis/new-svg.svg"
              alt=""
            />
          </div>
        </div>
        <div class="job-right-div h-100">
          <div class="job-right-inner-div h-100">
            <div
              class="set-right-container-overflow pr-2"
              style="overflow-x: hidden; overflow-y: auto"
            >
              <div class="d-flex align-items-center" v-if="jobDataLoader">
                <div style="width: 80px" class="mb-4">
                  <img src="../../assets/NewJobsRegis/job-icon.svg" alt="" />
                </div>
                <div style="width: 93%">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                    "
                  >
                    <b-skeleton class="w-50"></b-skeleton>
                    <div>
                      <b-button
                        @click="openApplyJob = true"
                        class="
                          new-blueBtn
                          w-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                        >Apply Job
                      </b-button>
                    </div>
                  </div>
                  <b-skeleton class="w-75"></b-skeleton>

                  <b-skeleton class="w-50"></b-skeleton>
                  <b-skeleton class="w-50"></b-skeleton>

                  <div
                    class="
                      mt-1
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                    "
                  >
                    <b-skeleton class="w-75"></b-skeleton>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center" v-else>
                <div class="set-icon-width mb-4 mobile-none">
                  <img src="../../assets/NewJobsRegis/job-icon.svg" alt="" />
                </div>
                <div class="set-inner-div-width">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                    "
                  >
                    <div class="mobile-set">
                      <div class="set-icon-width laptop-none">
                        <img
                          src="../../assets/NewJobsRegis/mobile-job-icon.svg"
                          alt=""
                        />
                      </div>
                      <div class="job-right-head">{{ jobData.title }}</div>
                    </div>
                    <div class="mobile-none">
                      <b-button
                        @click="routeToApplyJob()"
                        class="
                          new-blueBtn
                          w-100
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                        >Apply Job</b-button
                      >
                    </div>
                  </div>
                  <div class="mt-1 job-right-subhead">
                    {{ jobData.customerName }}
                  </div>
                  <div
                    class="d-flex align-items-center w-100 mobile-set-column"
                  >
                    <div
                      class="d-flex align-items-center mr-3 mt-1"
                      style="min-width: auto; max-width: 60%"
                    >
                      <div>
                        <img
                          src="../../assets/NewJobsRegis/location.svg"
                          alt=""
                        />
                      </div>
                      <div class="job-right-fonts ml-2 pointer">
                        {{ jobData.location[0] }}
                        <span
                          v-if="jobData.location.length > 1"
                          class="pointer"
                          @click="scrollToRef('loc')"
                        >
                          <u>+ {{ jobData.location.length - 1 }} More</u>
                        </span>
                      </div>
                    </div>

                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex align-items-center mr-3 mt-1"
                        v-if="
                          jobData.customFields &&
                          jobData.customFields.experienceRequired
                        "
                      >
                        <div>
                          <img
                            src="../../assets/NewJobsRegis/experience.svg"
                            alt=""
                          />
                        </div>
                        <div class="job-right-fonts ml-2">
                          {{
                            jobData.customFields.experienceRequired == "others"
                              ? "12+ Years"
                              : jobData.customFields.experienceRequired ==
                                "12+ years"
                              ? "12+ Years"
                              : jobData.customFields.experienceRequired +
                                " Years"
                          }}
                        </div>
                      </div>

                      <div
                        class="d-flex align-items-center mt-1"
                        v-if="jobData.jobType"
                      >
                        <div>
                          <img
                            src="../../assets/NewJobsRegis/working-time.svg"
                            alt=""
                          />
                        </div>
                        <div class="job-right-fonts ml-2">
                          {{ jobData.jobType }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="set-posted-data w-100">
                    <div
                      class="d-flex align-items-center mt-1"
                      v-if="jobData.skills"
                    >
                      <div class="skills-font">
                        <span class="laptop-none">Skills:</span>
                        <img
                          class="mobile-none"
                          src="../../assets/NewJobsRegis/skills.svg"
                          alt=""
                        />
                      </div>
                      <div class="job-right-fonts ml-2">
                        {{ jobData.skills.slice(0, 5).join(", ") }}
                        <span
                          class="pointer"
                          @click="scrollToRef('skill')"
                          v-if="jobData.skills.length > 4"
                        >
                          <u>+ {{ jobData.skills.length - 4 }} More</u>
                        </span>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center mt-1"
                      v-if="jobData.postedAt"
                    >
                      <div>
                        <img src="../../assets/NewJobsRegis/timee.svg" alt="" />
                      </div>
                      <div class="job-right-fonts ml-2">
                        {{ jobData.postedAt }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 jobs-right-second-head">Job Description</div>
              <div class="mt-2 jobs-right-second-subhead">
                <b-skeleton
                  v-if="jobDataLoader"
                  class="w-75 h-100px"
                ></b-skeleton>
                <div class="mt-1" v-html="jobData.description" v-else></div>
              </div>
              <div class="mt-2 jobs-right-second-head" ref="loc">Location</div>
              <div class="mt-2 jobs-right-second-subhead">
                {{ jobData.location.join(", ") }}
              </div>
              <!-- <div class="mt-2 jobs-right-second-head" ref="skill">Skills</div>
              <div class="mt-2 jobs-right-second-subhead">
                {{ jobData.skills.join(", ") }}
              </div> -->
              <div
                ref="skill"
                class="
                  mt-2
                  d-flex
                  align-items-center
                  justify-content-between
                  w-100
                "
              >
                <div class="jobs-right-second-head">
                  Skills you need to prepare on for this Job:
                </div>
                <div class="jobs-right-blue-font d-flex align-items-center">
                  <span class="mobile-none">Gathered by Hire3x</span>
                  <img
                    src="../../assets/NewJobsRegis/AI small.svg"
                    class="ml-2"
                    alt=""
                  />
                </div>
              </div>
              <div class="mt-1 jobs-right-head-subhead">
                Increase your chances of getting hired by 2x
              </div>

              <div class="flex-wrap d-flex align-items-center">
                <div
                  class="job-skills text-capitalize mt-2"
                  v-for="skill in jobData.skills"
                  :key="skill"
                >
                  {{ skill }}
                </div>
              </div>

              <!-- <hr />

              <div class="mt-2 jobs-right-second-head">
                Assessments to practice for this job
              </div>
              <div class="js-carousel-parent">
                <b-carousel
                  id="carousel-1"
                  :interval="400000"
                  controls
                  img-width="1024"
                  img-height="480"
                  @sliding-start="onSlideStart"
                  @sliding-end="onSlideEnd"
                >
                  <b-carousel-slide v-for="loop in loopvar" :key="loop">
                    <div
                      v-for="loop in loopvar"
                      :key="loop"
                      class="js-carousel-card"
                    >
                      <div class="d-flex align-items-center w-100">
                        <div class="mb-5" style="width: 80px">
                          <img
                            src="../../assets/NewJobsRegis/assess-icon.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 93%">
                          <div class="js-carousel-card-head d-flex">
                            Senior Software Developer Technical and
                            Non-technical Assessments
                          </div>
                          <div
                            class="mt-1 js-carousel-card-subhead-head d-flex"
                          >
                            Topic Name
                          </div>
                          <div class="mt-1 js-carousel-card-subhead d-flex">
                            Software Developer - Mid Senior
                          </div>
                        </div>
                      </div>
                      <hr class="mt-1 mb-1" />
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <div class="d-flex align-items-center">
                            <div>
                              <img
                                src="../../assets/NewJobsRegis/timeline.svg"
                                alt=""
                              />
                            </div>
                            <div class="js-carousel-card-font">90 Min</div>
                          </div>
                          <div class="ml-2 mr-2">
                            <img
                              src="../../assets/NewJobsRegis/line.svg"
                              alt=""
                            />
                          </div>
                          <div class="d-flex align-items-center">
                            <div>
                              <img
                                src="../../assets/NewJobsRegis/stats.svg"
                                alt=""
                              />
                            </div>
                            <div>
                              <span class="js-carousel-card-subhead-head">
                                Level:
                              </span>
                              <span class="js-carousel-card-font">02</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <div class="js-carousel-card-test-font">
                            Take Test
                          </div>
                          <div class="ml-2">
                            <img
                              src="../../assets/NewJobsRegis/rightArrow.svg"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-carousel-slide>
                </b-carousel>
              </div>

              <div class="mt-2 jobs-right-second-head">
                Jobs you might be looking for
              </div>
              <div class="jobs-carousel-parent">
                <b-carousel
                  id="carousel-1"
                  :interval="400000"
                  controls
                  img-width="1024"
                  img-height="480"
                  @sliding-start="onSlideStart"
                  @sliding-end="onSlideEnd"
                >
                  <b-carousel-slide v-for="loop in loopvar" :key="loop">
                    <div
                      v-for="loop in loopvar"
                      :key="loop"
                      class="js-carousel-card"
                    >
                      <div class="d-flex align-items-center w-100">
                        <div class="mb-5" style="width: 80px">
                          <img
                            src="../../assets/NewJobsRegis/inner-jobs-icon.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 93%">
                          <div class="js-carousel-card-head d-flex">
                            UI UX Designer
                          </div>
                          <div class="mt-1 js-carousel-card-subhead d-flex">
                            Software Developer - Mid Senior
                          </div>
                          <div class="d-flex align-items-center w-100">
                            <div class="js-carousel-card-subhead">
                              Bangalore
                            </div>
                            <div class="ml-2 mr-2">
                              <img
                                src="../../assets/NewJobsRegis/round-circle.svg"
                                alt=""
                              />
                            </div>
                            <div class="js-carousel-card-subhead">
                              Full Time
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-carousel-slide>
                </b-carousel>
              </div>-->
            </div>

            <div class="laptop-none apply-job-footer bluebtn">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4"
                style="width: 150px"
                @click="routeToApplyJob()"
                >Apply</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- apply job transition -->
    <!-- <transition name="slide"> -->
    <div class="job-slide" v-if="openApplyJob">
      <div class="h-100">
        <div class="job-height-overflow">
          <div class="d-flex align-items-center">
            <div class="pointer">
              <img
                src="../../assets/New-imgs/interviewProcess-icons/newInt-backBtn-arrow.svg"
                alt=""
                class="mr-3 pointer"
                @click="goBack()"
              />
            </div>
            <div class="newJD-heading">Apply Job</div>
          </div>
          <div class="mt-2">
            <FormShimmer v-if="dataLoading" />
            <!-- Custom Fields content -->
            <div class="mt-2 h-100" v-else>
              <b-row>
                <b-col
                  v-for="(field, index) in basicArray"
                  :key="index"
                  :cols="field.cols"
                  class="relativeclass mt-2"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="
                    !field.hide &&
                    field.key != 'source' &&
                    field.key != 'otherSource'
                  "
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv mt-4"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      :maxFileSize="field.maxFileSize"
                      :showResumeLoader="showResumeLoader"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      :maxFileSize="field.maxFileSize"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :vmodel="getVmodel(field)"
                      :showError="getError(field)"
                      :format="field.dateTimeFormat"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>

                  <template v-if="touchedFields[field.key]">
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>

              <div
                class="d-flex align-items-center mt-4"
                v-if="advanceArray.length > 0"
              >
                <div @click="showAdvance = !showAdvance">
                  <img
                    v-if="showAdvance"
                    src="../../assets/customfield/modalTopArrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/customfield/modalDownArrow.svg"
                    alt=""
                  />
                </div>
                <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
                <div class="modal-horizontal-line"></div>
              </div>

              <b-row v-if="showAdvance">
                <b-col
                  v-for="(field, index) in advanceArray"
                  :key="index"
                  :cols="field.cols"
                  class="relativeclass mt-2"
                  :class="
                    field.controlType == 'boolean'
                      ? 'd-flex align-items-center'
                      : ''
                  "
                  v-show="!field.hide"
                >
                  <div
                    v-if="
                      field.controlType == 'text' ||
                      field.controlType == 'email' ||
                      field.controlType == 'number'
                    "
                    class="topDiv mt-3"
                  >
                    <InputField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :vmodel="getVmodel(field)"
                      :showError="getError(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'single_select'"
                    class="topDiv mt-3"
                  >
                    <SelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'multi_select'"
                    class="topDiv mt-3"
                  >
                    <MultiSelectCustom
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :api="field.apiEndpoint"
                      :values="field.values"
                      :dropdown="field.dropdown"
                      :fieldType="field.fieldType"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      :showError="getError(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'rich_text_box'"
                    class="topDiv mt-3"
                  >
                    <CustomQuillEditor
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'boolean'"
                    class="topDiv mt-4"
                  >
                    <SwitchBox
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :vmodel="getVmodel(field)"
                      :id="field.key"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>

                  <div
                    v-else-if="field.controlType == 'upload_file'"
                    class="topDiv mt-3"
                  >
                    <UploadDocument
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :vmodel="getVmodel(field)"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'multi_text'"
                    class="topDiv mt-3"
                  >
                    <FormTags
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :fileFormat="field.fileFormat"
                      :showError="getError(field)"
                      :maxFileSize="field.maxFileSize"
                      :vmodel="getVmodel(field)"
                      @select-value="updateFieldValue(field, $event)"
                      @handle-input="handleInput(field)"
                      @handle-blur="handleBlur(field)"
                    />
                  </div>
                  <div
                    v-else-if="field.controlType == 'date'"
                    class="topDiv mt-3"
                  >
                    <DateField
                      :type="field.controlType"
                      :label="field.label"
                      :mandatory="field.mandatory"
                      :placeholder="field.placeholder"
                      :id="field.key"
                      :showError="getError(field)"
                      :vmodel="getVmodel(field)"
                      :format="field.dateTimeFormat"
                      @select-value="updateFieldValue(field, $event)"
                    />
                  </div>

                  <template v-if="touchedFields[field.key]">
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-if="field.mandatory && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                    <div
                      class="newInt-required-validation-font mt-1"
                      v-else-if="field.limit > 0 && !validateField(field)"
                    >
                      {{ valText[field.key] }}
                    </div>
                  </template>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end w-100 job-footer">
          <div class="position-relative">
            <b-button
              @click="showSpinner ? '' : validateForm()"
              class="new-blueBtn pl-4 pr-4 mr-2"
              :class="
                showSpinner ? 'applyjob-loader-class defaultCursor' : 'pointer'
              "
            >
              {{ showSpinner ? "" : "Apply Job" }}
            </b-button>
            <div v-if="showSpinner" class="applyjob-loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import newCandidateMixin from "../../components/mixin/newCandidateMixin";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Studentregistration",
  data() {
    return {
      dataLoading: false,
      loopvar: 3,
      openApplyJob: false,
      openDropdown: false,
      jobDataLoader: true,
      disabled: true,
      jobData: {},
      numberOfLines: 0,
      showSpinner: false,
      showAdvance: true,
      applied: false,
    };
  },
  validations: {
    selectedSlot: {
      date: {
        required,
      },
      time: {
        required,
      },
    },
  },
  mixins: [newCandidateMixin],
  watch: {
    $route() {
      if (this.$route.query.apply) {
        this.openApplyJob = true;
      } else {
        this.resetRoute();
      }
      this.handleResize();
    },
  },
  mounted() {
    // Initial call to getColumn when component is mounted
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    // Clean up event listener when component is destroyed
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    scrollToRef(childRef) {
      const target = this.$refs[childRef];

      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    },
    routeToApplyJob() {
      this.$router.push({
        name: "JobRegistration",
        query: {
          apply: true,
          jobID: this.$route.query.jobID,
        },
      });
      this.openApplyJob = true;
      this.handleResize();
    },
    goToHelp() {
      window.open(
        "https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/Job+Registration+Form.pdf",
        "_blank"
      );
    },
    goToHire3x() {
      window.open("https://hire3x.com/", "_self");
    },
    resetRoute() {
      this.goBack();
      this.getJobDetails();
    },
    goBack() {
      this.$router.push({
        name: "JobRegistration",
        query: {
          jobID: this.$route.query.jobID,
        },
      });
      this.openApplyJob = false;
    },
    handleResize() {
      // Call getColumn on resize event
      this.basicArray.forEach((field) => {
        field.cols = this.getColumn(field.controlType);
      });
      this.advanceArray.forEach((field) => {
        field.cols = this.getColumn(field.controlType);
      });
      this.$forceUpdate();
    },
    goToRegister() {
      window.open("https://app.hire3x.com/register", "_blank");
    },
  },
};
</script>

<style>
.applyjob-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 96px;
}

.applyjob-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 0px;
}
.gap-1rem {
  gap: 1rem;
}

.gap-5rem {
  gap: 0.5rem;
}

.job-parentDiv {
  position: relative;
  height: calc(100vh - 70px);
  top: 70px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-image: url("../../../src/assets/NewJobsRegis/jobs-main-svg.png");
  background-size: cover;
  padding: 25px 29px;
}

.jov-main-divs {
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

.job-left-div {
  box-sizing: border-box;
  background: #e9f0f5;
  border-radius: 5px;
  width: 40%;
  overflow-x: hidden;
  overflow-y: auto;
}

.job-left-innerdiv {
  /* margin-top: 16%; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 10%;
}

.job-left-innerdiv-height {
  height: 45%;
}

@media screen and (max-width: 1746px) {
  .job-left-innerdiv-height {
    height: 44%;
  }
}

@media screen and (max-width: 1536px) {
  .job-left-innerdiv-height {
    height: 44%;
  }
}

@media screen and (max-width: 1280px) {
  .job-left-innerdiv-height {
    height: 43%;
  }
}

@media screen and (max-width: 1098px) {
  .job-left-innerdiv-height {
    height: 70%;
  }
}

.job-left-head {
  font-family: var(--lato);
  font-weight: 600;
  font-size: 29px;
  color: #4c78ce;
}

.job-left-subhead {
  width: 90%;
  font-family: var(--montserrat);
  font-weight: 400;
  font-size: 18px;
  text-transform: capitalize;
  color: #646587;
}

.job-right-div {
  background-color: #fff;
  width: 60%;
  padding: 20px 22px;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 5px;
}

.job-right-inner-div {
  background: rgba(32, 99, 155, 0.08);
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 21px;
  padding: 20px 15px;
}

.job-right-head {
  font-family: var(--lato);
  font-weight: 500;
  font-size: 20px;
  color: #000000;
}

.job-right-subhead {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 13px;
  color: #333333;
}

.job-right-fonts {
  font-family: var(--montserrat);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #7a7a7a;
}

.jobs-right-second-head {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #000022;
}

.jobs-right-second-subhead {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 13px;
  color: #7a7a7a;
}

.jobs-right-blue-font {
  font-family: var(--lato);
  font-weight: 500;
  font-size: 16px;
  color: #20639b;
}

.jobs-right-head-subhead {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.job-skills {
  padding: 7px 10px;
  gap: 10px;
  background: #fdebd9;
  border-radius: 7.00472px;
  font-family: var(--lato);
  font-weight: 500;
  font-size: 14px;
  color: #f59e4d;
  margin-right: 15px;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

.job-slide {
  position: absolute;
  width: 59%;
  height: calc(100vh - 118px);
  right: 27px;
  top: 94px;
  z-index: 5;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
}

.job-height-overflow {
  padding: 30px;
  height: calc(100vh - 200px);
  overflow-x: hidden;
  overflow-y: auto;
}

.job-footer {
  padding: 20px 10px;
  border-top: 1px solid #d7d7d7;
  border-radius: 0px 0px 12px 12px;
}

.hire3x-container {
  background-color: #e9f0f5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.hire3x-container-head {
  font-family: "Satoshi", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #344054;
}

.hire3x-container-subhead {
  font-family: "Satoshi", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #344054;
}

.or-font {
  font-family: "Satoshi", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}

.help-font {
  font-family: "Satoshi", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #7a7a7a;
}

.set-icon-width {
  width: 80px;
}

.set-inner-div-width {
  width: 93%;
}

.laptop-none {
  display: none;
}

.set-posted-data {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.set-right-container-overflow {
  height: 100%;
}

.js-carousel-parent {
  height: 150px;
}

.js-carousel-parent .carousel {
  height: 100%;
}

.js-carousel-parent .carousel-inner {
  height: 100%;
}

.js-carousel-parent .carousel-item.active {
  height: 100%;
}

.js-carousel-parent .carousel-caption {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  left: 0px;
  padding: 0;
  width: 99%;
  height: 100%;
  bottom: 0px;
}

.js-carousel-parent .carousel-control-prev {
  width: 6%;
  left: -17px;
  opacity: 1;
  top: 80px;
  height: fit-content !important;
}

.js-carousel-parent .carousel-control-next {
  width: 6%;
  right: -10px;
  opacity: 1;
  top: 80px;
  height: fit-content !important;
}

.js-carousel-parent .carousel-control-prev-icon {
  background-image: url("../../assets/NewJobsRegis/left-arrow.svg") !important;
  width: 40px;
  height: 40px;
  transform: rotate(0deg);
  left: unset !important;
  position: absolute;
  top: unset !important;
}

.js-carousel-parent .carousel-control-next-icon {
  background-image: url("../../assets/NewJobsRegis/right-arrow.svg") !important;
  width: 40px;
  height: 40px;
  transform: rotate(0deg);
  right: unset !important;
  position: absolute;
  top: unset !important;
}

.js-carousel-card {
  background: #fff;
  margin: 10px;
  width: 32%;
  height: 100%;
  padding: 10px;
}

.js-carousel-card-head {
  font-family: var(--lato);
  font-weight: 400;
  font-size: 13px;
  color: #20639b;
}

.js-carousel-card-subhead-head {
  font-family: var(--montserrat);
  font-weight: 400;
  font-size: 10px;
  color: #3a3c40;
}

.js-carousel-card-subhead {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 12px;
  color: #3a3c40;
}

.js-carousel-card-font {
  font-family: var(--montserrat);
  font-weight: 400;
  font-size: 10px;
  color: #3a3c40;
}

.js-carousel-card-test-font {
  font-family: var(--montserrat);
  font-weight: 600;
  font-size: 12px;
  color: #20639b;
}

.select-slot-font {
  font-family: var(--montserrat);
  font-weight: 600;
  font-size: 14px;
  color: #344054;
}

.select-slot-dropdown {
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  width: 160px;
  padding: 3px 10px;
}

.select-slot-dropdown-disable {
  background-color: #f7f7f7;
  cursor: not-allowed;
}

.select-slot-dropdown-head {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.select-slot-container {
  background: #f1f7ff;
  border: 1px solid rgba(1, 119, 251, 0.25);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 20%;
  padding-block: 10px;
}

.select-time-container {
  background: #f1f7ff;
  border: 1px solid rgba(1, 119, 251, 0.25);
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 20%;
  padding-block: 13px;
}

.select-slot-container-selected {
  background: #20639b;
  border: 1px solid #20639b;
}

.select-slot-container-head {
  font-family: var(--montserrat);
  font-weight: 600;
  font-size: 12px;
  color: #333333;
}

.select-slot-container-head-selected {
  font-family: var(--montserrat);
  font-weight: 600;
  font-size: 12px;
  color: #ffffff;
}

.select-slot-container-subhead {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 12px;
  color: #333333;
}

.select-slot-container-subhead-selected {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
}

.jobs-carousel-parent {
  height: 105px;
}

.jobs-carousel-parent .carousel {
  height: 100%;
}

.jobs-carousel-parent .carousel-inner {
  height: 100%;
}

.jobs-carousel-parent .carousel-item.active {
  height: 100%;
}

.jobs-carousel-parent .carousel-caption {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  left: 0px;
  padding: 0;
  width: 99%;
  height: 100%;
  bottom: 0px;
}

.jobs-carousel-parent .carousel-control-prev {
  width: 6%;
  left: -17px;
  opacity: 1;
  top: 60px;
  height: fit-content !important;
}

.jobs-carousel-parent .carousel-control-next {
  width: 6%;
  right: -10px;
  opacity: 1;
  top: 60px;
  height: fit-content !important;
}

.jobs-carousel-parent .carousel-control-prev-icon {
  background-image: url("../../assets/NewJobsRegis/left-arrow.svg") !important;
  width: 40px;
  height: 40px;
  transform: rotate(0deg);
  left: unset !important;
  position: absolute;
  top: unset !important;
}

.jobs-carousel-parent .carousel-control-next-icon {
  background-image: url("../../assets/NewJobsRegis/right-arrow.svg") !important;
  width: 40px;
  height: 40px;
  transform: rotate(0deg);
  right: unset !important;
  position: absolute;
  top: unset !important;
}

.open-dropdown {
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  top: 33px;
  right: 0px;
  position: absolute;
  z-index: 2;
  width: 100%;
}

.open-dropdown-content {
  background: #f9f9f9;
  font-size: 13px;
  color: #3a3c40;
  font-weight: 500;
  font-family: var(--lato);
  border: none;
  text-align: left;
  padding: 8px 12px;
  word-break: break-all;
}

.open-dropdown-content-selected {
  background: #c8d9e5 !important;
}

.open-dropdown-content:hover {
  background: #e8eff4 !important;
}

.width-inputField {
  width: 35%;
}

.set-direction {
  display: flex;
  align-items: center;
}

.lap-block {
  display: none;
}

.skills-font {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 10px;
  color: rgba(122, 122, 122, 0.7);
}

.reg-form-validation {
  font-family: var(--montserrat);
  font-weight: 500;
  font-size: 11px;
  color: #eb0002;
}

.ml-3-query {
  margin-left: 15px;
}

.mr-3-query {
  margin: 0 15px;
}

/* mobile design starts from here */
@media only screen and (max-width: 600px) {
  .select-time-container {
    width: 45%;
    padding-block: 0;
    padding: 7px 7px;
  }

  .select-slot-container {
    width: 45%;
  }

  .select-slot-container-head {
    font-family: var(--montserrat);
    font-weight: 500;
    font-size: 12px;
    color: #333333;
  }

  .select-slot-container-subhead {
    font-family: var(--montserrat);
    font-weight: 500;
    font-size: 12px;
    color: #333333;
  }

  .select-slot-container-subhead-selected {
    font-family: var(--montserrat);
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
  }

  .select-slot-container-head-selected {
    font-family: var(--montserrat);
    font-weight: 500;
    font-size: 11px;
    color: #ffffff;
  }

  .job-parentDiv {
    background-image: none;
    padding: 0px;
    height: calc(100dvh - 70px);
  }

  .job-left-div {
    display: none;
  }

  .job-right-div {
    width: 100%;
  }

  .job-right-inner-div {
    padding: 0px;
  }

  .set-right-container-overflow {
    height: 93%;
    padding: 10px 10px;
    box-shadow: none;
  }

  .apply-job-footer {
    background: #ffffff;
    border-top: 1px solid rgba(140, 140, 140, 0.25);
    border-radius: 0px 0px 20px 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 7%;
  }

  .laptop-none {
    display: flex;
  }

  .lap-block {
    display: block;
  }

  .ml-3-query {
    margin-left: 0px;
  }

  .mr-3-query {
    margin: 0px;
  }

  .mobile-none {
    display: none;
  }

  .mobile-set {
    display: flex;
    align-items: center;
  }

  .set-icon-width {
    width: 48px;
  }

  .set-posted-data {
    display: flex;
    align-items: flex-start;
    flex-direction: column !important;
  }

  .js-carousel-parent .carousel-caption {
    flex-wrap: wrap;
  }

  .js-carousel-card {
    width: 100%;
  }

  .js-carousel-parent .carousel-control-prev-icon {
    display: none;
  }

  .js-carousel-parent .carousel-control-next-icon {
    display: none;
  }

  .jobs-carousel-parent .carousel-caption {
    flex-wrap: wrap;
  }

  .jobs-carousel-card {
    width: 100%;
  }

  .jobs-carousel-parent .carousel-control-prev-icon {
    display: none;
  }

  .jobs-carousel-parent .carousel-control-next-icon {
    display: none;
  }

  .job-slide {
    width: 100%;
    left: 0px;
    right: 0px;
    top: 70px;
    height: calc(100dvh - 70px);
  }

  .job-height-overflow {
    padding: 30px;
    height: 90%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .job-footer {
    border-top: 1px solid #d7d7d7;
    border-radius: 0px 0px 12px 12px;
    height: 10%;
    padding: 0px 10px 0px 0px;
    display: flex;
    align-items: center;
  }

  .text-align-center {
    text-align: center;
  }

  .hire3x-container {
    flex-direction: column;
    align-items: center;
  }

  .width-inputField {
    width: 100%;
  }

  .set-direction {
    flex-direction: column;
  }

  .white-container {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100% !important;
  }

  .time-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
  }

  #appliedbox {
    margin-top: 50px;
  }
  .mobile-set-column {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
/* mobile design ends here */

.hr-back {
  background-color: #8c8c8c;
}

.applied-blue-div {
  background-color: #e9f0f5;
  border-radius: 6px;
  width: 100%;
  padding: 40px 15px;
}

.back-career-txt {
  font-family: var(--montserrat);
  font-size: 13px;
  font-weight: 600;
  color: #20639b;
}

.white-container {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  width: 60%;
}

.bluedot {
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: #20639b;
}

.stureg-grey-txt {
  font-family: var(--montserrat);
  font-size: 16px;
  font-weight: 600;
  color: #646587;
}

.stureg-grey-txt-2 {
  font-family: var(--lato);
  font-size: 12px;
  font-weight: 400;
  color: #646587;
}

.stureg-grey-txt-3 {
  font-family: var(--montserrat);
  font-size: 12px;
  font-weight: 400;
  color: #333333;
}

.stureg-grey-txt-4 {
  font-family: var(--montserrat);
  font-size: 12px;
  font-weight: 500;
  color: #333333;
}
</style>
